import {
  PasswordChangeFormValues,
  PasswordChangeFormViolation,
} from 'types/passwordChangeFormTypes';
import { INPUT_PASSWORD_MIN_LENGTH } from 'utils/constants';

export const createPasswordChangeFormValues = (): PasswordChangeFormValues => ({
  currentPassword: '',
  nextPassword: '',
  nextPasswordRepeat: '',
});

type ValidatorParams = {
  shouldValidateCurrentPassword?: boolean;
};

export const validatePasswordChangeFormValues = (
  values: PasswordChangeFormValues,
  params: ValidatorParams = { shouldValidateCurrentPassword: false }
): PasswordChangeFormViolation[] => {
  const { shouldValidateCurrentPassword } = params;

  const violations: PasswordChangeFormViolation[] = [];

  if (shouldValidateCurrentPassword) {
    if (!values.currentPassword) {
      violations.push({
        name: 'CurrentPasswordMissed',
      });
    }
  }

  if (!values.nextPassword) {
    violations.push({
      name: 'NextPasswordMissed',
    });
  }

  if (values.nextPassword.length < INPUT_PASSWORD_MIN_LENGTH) {
    violations.push({
      name: 'NextPasswordTooShort',
    });
  }

  if (!values.nextPasswordRepeat) {
    violations.push({
      name: 'NextPasswordRepeatMissed',
    });
  }

  if (values.nextPassword !== values.nextPasswordRepeat) {
    violations.push({
      name: 'NextPasswordRepeatDoNotMatch',
    });
  }

  return violations;
};

export const createPasswordChangeFormViolationLense = (
  violation: PasswordChangeFormViolation
) => ({
  isCurrentPasswordViolation() {
    switch (violation.name) {
      case 'CurrentPasswordMissed':
      case 'CurrentPasswordDoNotMatch':
        return true;
      default:
        return false;
    }
  },
  isNextPasswordViolation() {
    switch (violation.name) {
      case 'NextPasswordMissed':
      case 'NextPasswordTooShort':
        return true;
      default:
        return false;
    }
  },
  isNextPasswordRepeatViolation() {
    switch (violation.name) {
      case 'NextPasswordRepeatMissed':
      case 'NextPasswordRepeatDoNotMatch':
        return true;
      default:
        return false;
    }
  },
});
